import { TextField, MenuItem, Stack } from "@mui/material"
import { useState, useEffect } from "react"
import { API } from "../../services/API/API";
import Chip from '../Tools/Chip';
import { txt } from "../../services/translation";

export default function CategorySelect({value, onChange, required, disabled, sx}){

    const [categories, setCategories] = useState([]);
    const [val, setVal] = useState('')

    useEffect(() => {

        API.getCategories()
            .then(r => {
                setCategories(Array.isArray(r.data) ? r.data : [])
                return setVal(value);
            })
            .catch(e => console.log(e))

    }, [value])

    const handleChange = id => {
        setVal(id);
        return onChange(id);
    }

    return <TextField
        label={txt('healthSector')}
        select
        size='small'
        value={val}
        onChange={e => handleChange(e.target.value)}
        required={required ? true : false}
        disabled={disabled}
        sx={sx || {}}
    >
        {!required && <MenuItem value='all'>{txt('all')}</MenuItem>}
        {categories.map(c => 
            <MenuItem key={c.id} value={c.id}>
                <Stack direction='row' alignItems='center' spacing={2}>
                    <Chip color={c.color} opacity={0.8} />
                    <span>{txt(c.id)}</span>
                </Stack>
            </MenuItem>    
        )}
    </TextField>
}